<template>
    <div>
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h3 class="mb-0">{{ trans('operators.overview.title') }}</h3>
            <div class="d-flex align-items-end center gap-3">
                <small class="text-muted">{{
                    trans('operators.overview.results.count', {
                        total: operators.length,
                    })
                }}</small>
                <modal-link v-if="!isTablet && hasAnyPermission('operator.create')" :href="route('operators.create')">{{
                    trans('operators.overview.action.add')
                }}</modal-link>
            </div>
        </div>

        <div v-if="operators.length === 0">
            <card style="padding: 0 !important">
                <div class="text-gray text-center">
                    <div class="text-semi-bold">
                        {{ trans('stakeholders.overview.empty.operators.title') }}
                    </div>
                    <div>
                        {{ trans('stakeholders.overview.empty.description') }}
                    </div>
                </div>
            </card>
        </div>
        <div v-else>
            <card v-for="operator in operators" :key="operator.id" card-classes="mb-2" style="padding: 0 !important">
                <header class="d-flex justify-content-between align-items-center">
                    <h4 class="h6">{{ operator.name }}</h4>
                    <div v-if="!isTablet && hasAnyPermission(['operator.update', 'operator.delete'])" class="d-flex gap-1">
                        <modal-link
                            v-if="hasAnyPermission('operator.update')"
                            :href="route('operators.edit', operator)"
                            :tooltip="trans('general.action.edit')"
                            icon="cil-pencil"
                        />
                        <jet-button
                            v-if="hasAnyPermission('operator.delete')"
                            v-c-tooltip="{
                                content: trans('general.action.delete'),
                            }"
                            :destructive="true"
                            class="btn-icon"
                            type="button"
                            variant="secondary"
                            @click="deleteOperator(operator)"
                        >
                            <icon name="cil-trash" />
                        </jet-button>
                    </div>
                </header>
                <section>
                    <row>
                        <column lg="2" md="3">
                            <div class="whitespace-nowrap">
                                {{
                                    trans('stakeholders.overview.assets_count.label', {
                                        count: operator.assetsCount || 0,
                                    })
                                }}
                            </div>
                            <div class="whitespace-nowrap">
                                {{
                                    trans('stakeholders.overview.locations_count.label', {
                                        count: operator.topLevelLocationsCount || 0,
                                    })
                                }}
                            </div>
                        </column>
                        <column>
                            <stakeholder-contact-list :title="trans('operators.overview.contacts.title')" :contacts="operator.contacts" />
                        </column>
                    </row>
                </section>
            </card>
        </div>
    </div>
</template>
<script setup>
import JetButton from '@/Jetstream/Button.vue';
import { eventBus, events } from '@/eventBus.js';
import Card from '@/Components/Card.vue';
import Row from '@/Components/Row.vue';
import { isTablet } from '@/Utils/UseMedia';
import { trans } from '@/mixins/i18n.js';
import { hasAnyPermission } from '@/mixins/hasAnyPermission.js';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import ModalLink from '@/Components/ModalLink.vue';
import StakeholderContactList from '@/Pages/Stakeholders/Components/StakeholderContactList.vue';

const page = usePage();
const operators = computed(() => page.props.operators?.data || []);

const deleteOperator = (item) => {
    eventBus.$emit(events.openConfirmDeleteStakeholderModal, {
        stakeholder: item,
        type: 'operator',
    });
};
</script>
